import { styled } from "@mui/material/styles"
import { Typography } from "@mui/material"

export const StyledShortenedTypography = styled(Typography)({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
})